(function () {
  // ↑ aumentei o limite para garantir que seu aparelho seja considerado mobile
  var MOBILE_MAX = 1024;                   // temporário: depois podemos voltar p/ 768
  var MAIN_SELECTOR = 'button[name="add"]';
  var LOG = true;                          // logs ligados p/ debug

  function log(){ if (LOG) try{ console.log('[sticky-buy]', ...arguments); }catch(e){} }

  function ensureBar() {
    var wrap = document.querySelector('.sticky-buy');
    if (wrap) return wrap;

    wrap = document.createElement('div');
    wrap.className = 'sticky-buy';

    var btn = document.createElement('button');
    btn.type = 'button';
    // herda o estilo do Craft + nossa classe
    btn.className = 'product-form__submit button button--full-width button--primary sticky-buy__btn';
    btn.textContent = 'Comprar agora';
    btn.setAttribute('aria-label', 'Comprar agora');

    btn.addEventListener('click', function () {
      var mainBtn = document.querySelector(MAIN_SELECTOR);
      var form = document.querySelector('form[action*="/cart/add"]');
      if (mainBtn && !mainBtn.disabled) { mainBtn.click(); return; }
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    wrap.appendChild(btn);
    document.body.appendChild(wrap);
    log('barra criada');
    return wrap;
  }

  function isMobile() {
    return (window.innerWidth || document.documentElement.clientWidth) <= MOBILE_MAX;
  }

  function isMainVisible() {
    var el = document.querySelector(MAIN_SELECTOR);
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    // visível se pelo menos 20px aparecem na viewport
    return r.top < (vh - 20) && r.bottom > 20;
  }

  function showBar() {
    var wrap = ensureBar();
    if (!wrap) return;
    wrap.style.display = 'block';
    var h = wrap.offsetHeight || 72;
    document.documentElement.style.setProperty('--sticky-buy-h', h + 'px');
    document.documentElement.classList.add('sticky-buy-visible');
    log('mostrar barra (h=' + h + ')');
  }

  function hideBar() {
    var wrap = document.querySelector('.sticky-buy');
    if (wrap) wrap.style.display = 'none';
    document.documentElement.classList.remove('sticky-buy-visible');
    document.documentElement.style.removeProperty('--sticky-buy-h');
    log('ocultar barra');
  }

  var ticking = false;
  function tick() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;

      var mainBtn = document.querySelector(MAIN_SELECTOR);
      if (!isMobile()) { log('não é mobile'); hideBar(); return; }
      if (!mainBtn) { log('botão principal não encontrado'); hideBar(); return; }

      if (isMainVisible()) { hideBar(); }
      else { showBar(); }
    });
  }

  function init() {
    ensureBar();
    // força uma avaliação imediata
    tick();
    // e repete após pequenos delays (garante em DOMs dinâmicos)
    setTimeout(tick, 200);
    setTimeout(tick, 600);
    setTimeout(tick, 1200);

    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    document.addEventListener('shopify:section:load', tick);
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest('[name="id"]'))) tick();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
